import { P00039DataRxTxIndex } from '../../P00039Sync';
import { IProduct } from '../../../IProduct';
import { Pool } from '../../../../../../apis/pool.api';

export function P00058InstallationReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.PompeVS_Controle,
    'pvCResetUsine',
    1,
    null,
    productClass,
  );
}
